import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";


const Longterm = () => {
  return (
    <Container>
    <h2 className="display-6 fw-bold my-4">Long-Term Archiving
    </h2>
    <hr />

    <p>To ensure permanent access to our publications, we work with different partners to archive our content:</p>

  
    <ul className="joab-common-para my-4">
        <li className="mb-2">A full archival copy of all publications is deposited in electronic format into Dutch National Library <Link to="https://www.kb.nl/"> (www.kb.nl) </Link> </li>

        <li className="mb-2">Life science-related journals are added into <Link to="https://pmc.ncbi.nlm.nih.gov/"> PubMed Central</Link>  once eligible.</li>
        

        <li className="mb-2">Authors are encouraged to self-archive the final version of their published articles into institutional repositories (such as those listed in the Directory of Open Access Repositories).</li>
       
    </ul>

   


  </Container>
  );
};

export default Longterm;
